<div class="padding">
	<b>Upload multiple shots</b>

	@if (uploadedImages.length > 0) {
		<div class="fix-width flex column bg-orange margin-top-small radius padding">
			<div class="flex center">
				<i class="fa fa-check margin-right-smallest"></i>
				<b>Check completed!</b>
			</div>

			<div class="margin-top-smallest">Checked {{ uploadedImages.length }} files. Please check the details below.</div>
		</div>

		<div class="flex center margin-top">
			<div class="flex flex-1 column">
				<div class="flex center red">
					<i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
					<b>{{ getUploadedImagesProblems().length }} invalid files:</b>
					<div class="hover flex hover center margin-left-small grey" (click)="copyErrorsToClipboard()">
						<i class="fa-regular fa-copy margin-right-smallest"></i>
						<span>copy list to clipboard</span>
					</div>
				</div>

				<div class="scrollable border padding-small flex column gap margin-top-small">
					@for (image of getUploadedImagesProblems(); track image) {
						<div class="flex center">
							<div class="placeholder" [style.background-image]="'url(' + image.blob + ')'"></div>

							<div class="flex red column margin-left-small">
								<div>{{ image.fileName }}</div>
								<div class="flex column start">
									<div class="bg-orange red radius padding-right-small padding-left-small flex center margin-top-smallest">
										<i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
										Invalid file name
									</div>
								</div>
							</div>
						</div>
					}

					@if (getUploadedImagesProblems().length == 0) {
						<div class="flex center">No invalid files!</div>
					}
				</div>
			</div>
			<div class="flex flex-1 column margin-left">
				<div class="flex center green">
					<i class="fa-solid fa-check margin-right-smallest"></i>
					<b>{{ getUploadedImagesOk().length }} valid files:</b>
				</div>

				<div class="scrollable border padding-small flex column gap margin-top-small">
					@for (image of getUploadedImagesOk(); track image) {
						<div class="flex center">
							<div class="placeholder" [style.background-image]="'url(' + image.blob + ')'"></div>

							<div class="flex primary column margin-left-small">
								<div>{{ image.fileName }}</div>
								<div class="flex column start">
									<div class="bg-green white radius padding-right-small padding-left-small flex center margin-top-smallest">
										<i class="fa-solid fa-check margin-right-smallest"></i>
										Valid
									</div>
								</div>
							</div>
						</div>
					}

					@if (getUploadedImagesOk().length == 0) {
						<div class="flex center">No files.</div>
					}
				</div>
			</div>
		</div>
	} @else {
		<div class="bg-lightest-blue margin-top-small radius">
			<div class="padding-small padding-left bg-primary white">
				<i class="fa fa-info-circle margin-right-smallest"></i>
				<b>Renaming tip!</b>
			</div>

			<div class="flex column padding">
				<div class="margin-bottom-smallest">Please rename your files following this pattern:</div>

				<div class="flex center primary margin-bottom-smallest">
					<i class="fa-solid fa-image fa-xl"></i>
					<div class="unicode margin-left-small flex center">
						{{ '{StyleCode}{TeamCode}{ColorCode}_{CodifiedUseCode}_{AspectRatio}.{FileExtension}' }}
					</div>
				</div>

				<div class="margin-bottom-smallest padding-top-smallest">Example:</div>

				@for (i of getExampleEstimatedCodes(); track i) {
					<div class="flex primary center margin-bottom-smallest">
						<i class="fa-solid fa-image fa-xl"></i>
						<div class="margin-left-small flex center">
							<span class="unicode">{{ i }}</span>
						</div>
					</div>
				}
			</div>
		</div>

		<div class="margin-top bg-light-grey border dashed justify-center center flex column fix-height {{ isDragging ? 'bg-lightest-blue' : '' }}" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
			@if (!isDragging) {
				<div class="flex column center grey margin-bottom">
					<span>Allowed formats: JPG, PNG, TIFF.</span>
					<span>Max file size: 10MB.</span>
				</div>

				<input type="file" #fileInput multiple (change)="onFilesSelected($event)" style="display: none" />

				<button (click)="fileInput.click()">
					<i class="fa-solid fa-upload margin-right-smallest"></i>
					Upload
				</button>
			} @else {
				<div class="flex column center primary">
					<i class="fa-solid fa-upload fa-2x margin-bottom-smallest"></i>
					<span>Drop your files here...</span>
				</div>
			}
		</div>
	}

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			@if (getUploadedImagesOk().length > 0) {
				<button (click)="confirm()">
					<i class="fa-solid fa-upload margin-right-smallest"></i>
					Upload {{ getUploadedImagesOk().length }} valid files
				</button>
			}
		</div>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
